import { Activity, BookOpen, Flag, Sparkles } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { getWhatsAppLink } from '../../../../modules/customer/utils/customer.utils';
import {
  TECEO_DOCS_URL,
  TECEO_NEWS_URL,
  TECEO_STATUS_URL,
  whatsapp,
} from '../../../../utils/constants';
import { UserMenuTestIds } from '../../../../utils/testIds/UserMenu.testIds';
import { UserMenuExternalLink } from './userMenu.types';

export const USER_MENU_ANCHOR_OFFSET = -8;

export const USER_MENU_EXTERNAL_LINKS: UserMenuExternalLink[] = [
  {
    testId: UserMenuTestIds.NEWS,
    label: LangEnum.GLOBAL_NEWS,
    icon: Sparkles,
    url: TECEO_NEWS_URL,
  },
  {
    testId: UserMenuTestIds.DOCS,
    label: LangEnum.GLOBAL_DOCS,
    icon: BookOpen,
    url: TECEO_DOCS_URL,
  },
  {
    testId: UserMenuTestIds.TECEO_STATUS,
    label: LangEnum.GLOBAL_TECEO_STATUS,
    icon: Activity,
    url: TECEO_STATUS_URL,
  },
  {
    testId: UserMenuTestIds.REPORT_PROBLEM,
    label: LangEnum.GLOBAL_REPORT_PROBLEM,
    icon: Flag,
    url: getWhatsAppLink({ phone: whatsapp.phoneWithoutDDI }),
  },
];
